import { render, staticRenderFns } from "./IconDecrease.vue?vue&type=template&id=6b22c2ed&scoped=true"
import script from "./IconDecrease.vue?vue&type=script&lang=js"
export * from "./IconDecrease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22c2ed",
  null
  
)

export default component.exports